import { useFormikContext } from 'formik'
import { ClearOrSaveButtons, ClearOrSaveButtonsProps } from './ClearOrSaveButtons'

type ClearOrSaveButtonsFormikProps = Omit<ClearOrSaveButtonsProps, 'onSubmit' | 'dirty'>

export const ClearOrSaveButtonsFormik = (props: ClearOrSaveButtonsFormikProps) => {
  const { submitForm, errors, dirty } = useFormikContext()

  return (
    <ClearOrSaveButtons
      {...props}
      saveButtonProps={{
        ...props.saveButtonProps,
        disabled:
          Object.keys(errors).length > 0 ||
          props.disabled ||
          props.saveButtonProps?.disabled ||
          !dirty,
      }}
      dirty={dirty}
      onSubmit={submitForm}
    />
  )
}
